import { createSlice } from '@reduxjs/toolkit';

export const travelerSlice = createSlice({
  name: 'traveler',
  initialState: {    
    info: {
      masterSale: {      
        air: [],
        lodging: [],
        cruise: [],
        service: [],
        advancePayments: [],
        rejectedPayments: [],
      },
    },   
    specialRequests: [],
    isLoading: false,
  },
  reducers: {   
    setInfo: (state, action) => {
      state.info = action.payload;
      state.isLoading = false;
    },
    setSpecialRequests: (state, action) => {
      state.specialRequests = action.payload;
    },
    setIsLoading: (state, action) => {
      state.isLoading = action.payload
    },
  }
});


// Action creators are generated for each case reducer function
export const { setInfo, setMasterSale, setSpecialRequests, setIsLoading
  } = travelerSlice.actions;